/**
 * Created by mauget on 9/28/16.
 */

import $ from 'jquery';
import _ from 'lodash';
import Rx from 'rx-lite';
import listService from 'ListService';
import constants from 'Constants';
import undoService  from 'UndoService';
import dashboardService from 'DashboardService';
import eventBus from 'EventBus';
import ConnectionTracker from 'ConnectionTracker';
import util from 'util/Util';
import crudController from 'CrudController';
import pasteCommandService from 'PasteCommandService';
import textConstants from 'TextConstants';
import focusController from 'FocusController';
import formService from 'FormService';

// TODO When resizeable circles (branches) are implmented, delete WANT_RESIZE_CIRCLES and its client conditionals
// Turn off resizing circles until implementation is working:
const WANT_RESIZE_CIRCLES = false;

const KEYDOWN = 'keydown';
const KEYUP = 'keyup';
const DEFAULT = 'default';

// Raw command verbal key codes used across Windows, Mac OS, and Linux

const
    KC_BKSP =  8,
    KC_TAB =  9,
    KC_DEL  = 46,
    KC_LC_A = 65,
    KC_LC_C = 67,
    KC_LC_X = 88,
    KC_LC_V = 86,
    KC_LC_S = 83,
    KC_LC_Y = 89,
    KC_LC_Z = 90,
    KC_LEFT = 37,
    KC_RIGHT = 39,
    KC_UP   = 38,
    KC_DOWN = 40
;


// Move a given HTML control as a function of arrow key code

const LAYOUT_MOVE_KEYSET = {
    [KC_RIGHT]: { delta: {dx: 1,  dy: 0} },
    [KC_LEFT]:  { delta: {dx:-1,  dy: 0} },
    [KC_UP]:    { delta: {dx: 0,  dy:-1} },
    [KC_DOWN]:  { delta: {dx: 0,  dy: 1} }
};


// Resize a given HTML control as a function of arrow key code

const LAYOUT_RESIZE_KEYSET = {
    [KC_RIGHT]: {dwidth: 1,  dheight: 0},
    [KC_LEFT]:  {dwidth:-1,  dheight: 0},
    [KC_UP]:    {dwidth: 0,  dheight:-1},
    [KC_DOWN]:  {dwidth: 0,  dheight: 1}
};

// This is a move specification for Behaviors and Workflow RECTANGULAR objects only.
// 1. o (x,y) coordinate names matched to FabricJS coordinate names
// 2. o Sign of movement direction for given key

const FAB_KEY_ACTION = {
    [KC_RIGHT]: { direction:  1, pfCoord: 'x', fabCoord: 'left', dim: 'width'},
    [KC_LEFT]:  { direction: -1, pfCoord: 'x', fabCoord: 'left', dim: 'width'},
    [KC_UP]:    { direction: -1 ,pfCoord: 'y', fabCoord: 'top',  dim: 'height'},
    [KC_DOWN]:  { direction:  1, pfCoord: 'y', fabCoord: 'top',  dim: 'height'}
};


const DOM_LOC = document.body;

const SILENT = constants.MODEL_SILENT;

// Behaviors and Workflow per-dot delta mapping as function of a positive direction dimension change; dot 0..4 map to (unused),E,S,W,N
// Connection dot numbers from PF. 1 is south; 0 is east; 3 is north; 2 is west; Ref from constants follows:

const RESIZE_STEP = 0.5;
const RS1 = RESIZE_STEP;

// An arrow key uses either left or top for a given dot, depending upon if key up/down or left/right
// Deltas are in object is shrinking direction. Reverse 'em when expanding the object.
const DOT_DELTAS = {

    // offset:    0       1       2       3
    // dir:       E       S       W       N

    left:[    -2*RS1,  -RS1,      0,    -RS1 ],
    top: [     -RS1,  -2*RS1,    -RS1,    0  ]
};


const RS = 0.5;
const RS2 = Math.sin(Math.PI / 4) * RS;

// Resize offset movement deltas for CIRCLE objects only (Behavior branch widgets / objects).
// 1. Circle connection points/dots use a separate connection point numbering scheme.
// 2. Circle's have eight connecton points, not four! DIFFERSs from the rectangle shapes!
// 3. Circles have 0 origin at South and proceed counter-clockwise.
// 4. The deltas reflect a shrinking delta. A growing delta would simple negate the signs first.
// 5. Each row of this table is a delta mapping for a given point of the circle.
// 6. Both dx and dy participate togehter to adjust its conncetion point location during contraction or expansion.

const CIRCLE_DOT_DELTAS = [
    // offset:  0     1     2    3     4     5     6     7
    // dir:     S    SE     E    NE    N    NW     W    SW

    {dx:  0, dy: -RS},  // S

    {dx: -RS2, dy: -RS2},  // SE

    {dx:  -RS, dy: RS },  // E ***

    {dx:  -RS2, dy: RS2},   // NE

    {dx:  0, dy: RS},  // N

    {dx:  RS2, dy: RS2},  // NW

    {dx:  RS, dy: -RS },  // W ok

    {dx:  RS2, dy: -RS2}  // SW
];

// Use these to enforce minimum dimensions on commands and stages
const MIN_DIMS = {
    'default': {width: 150, height: 44},
    'command_start': {width: 40, height: 40},
    'command_exit': {width: 40, height: 40},
    'command_multiple_branch': {width: 60, height: 60},
    'command_simple_branch': {width: 60, height: 60},
    'command_comment': {width: 30, height: 30}
};

//===============================================================================================
// This singleton routes certain magic keystrokes to handlers that carry out hotkey actions
// such as control delete, copy, cut, paste, and move. Don't call this code. Simply import
// it early.
//
// main.js is a good spot.
// (could handle in a catch, dampened by a timeout that stops all streams and restarts all)
//
// - Lou Mauget, September 28, 2016
//===============================================================================================
class KeyboardController {

    constructor() {
        this.init();
    }

    get $aForm() {
        if (!this._$aForm) {
            this._$aForm = $('#aForm');
        }
        return this._$aForm;
    }

    init() {

        // TODO future: restart any stream listener that aborts. Today, an exception stops a stream for app life-cycle.
        try {
            this.createStreams();
        } catch(err) {
            console.log(`Keyboard controller`, err);
        }
    }

    // Create subscribed keyboard event streams used throughout the life-cycle of the app instance.

    createStreams() {
        
        // Handle cntrl-a key down select all

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => k.keyCode === KC_LC_A && this.isJustCntrlKey(k) )
            .subscribe(ev => {
                // Don't return ctrl-a: MS Windows selects everything on the page if it sees it.
                if (this.isValidKBControl(ev.target)) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    crudController.selectAll();
                } else if (this.isBehavior || this.isWorkflow)  {
                    ev.returnValue = true;
                    if (ev.target && ev.target.type !== 'text' && ev.target.type !== 'textarea' && ev.target.type !== 'password') {
                        this.stopEvent(ev);
                        ev.returnValue = false;
                        crudController.selectAllCanvasObjects();
                    }
                }
            });

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_TAB) && !this.isAnyModeKey(k))
            .subscribe(ev => {
                ev.returnValue = true;
            });

        // Handle backspace or del key if selected control in a layout

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_DEL || k.keyCode === KC_BKSP) && !this.isAnyModeKey(k))
            .subscribe(ev => {
                let isIExplorer = () => {
                    return !!(((false) || (document.documentMode)) || (!(document.documentMode) && window.StyleMedia));
                };

                

                let verifyEvent = (ev) => {
                    return ev.target.type && 
                           (ev.target.type !== 'text' && 
                           ev.target.type !== 'textarea' && 
                           ev.target.type !== 'number') ||                           
                           ev.target.type === '' || 
                           ev.target.id === 'aForm' || 
                           ev.target.localName === 'body' || 
                           ev.target.localName === 'aPage' ||       
                           ev.target.parentElement.id === 'aPage' ||
                           isIExplorer();            
                };

                

                let noTextOrSuppr = (ev)=> {
                    let isText = false;
                    let isSuppr = false;
                    if (ev.target) {
                        isText = ev.target.type !== 'text' && ev.target.type !== 'textarea' && ev.target.type !== 'password';
                    }

                    if (ev.keyCode) {
                        isSuppr = ev.keyCode.toString() !== '46'; 
                    }
                    return isText && isSuppr;
                }

                console.log("Legacy KeyDown:", {
                    keyCode: ev.keyCode,
                    targetType: ev.target.type,
                    targetId: ev.target.id,
                    targetLocalName: ev.target.localName,
                    isSelectionOnMobile: this.isSelectionOnMobile,
                    isValidKB: this.isValidKBControl ? this.isValidKBControl(ev.target) : 'N/A', // Check if function exists
                    verifyEventResult: verifyEvent(ev), // Log result of verifyEvent
                    noTextOrSupprResult: noTextOrSuppr(ev) // Log result of noTextOrSuppr
                });

                if (this.isSelectionOnLayoutOrReport || this.isSelectionOnMobile){
                    if (this.isValidKBControl(ev.target)) {  
                        this.stopEvent(ev);
                        ev.returnValue = false;        
                        
                        if(this.isSelectionOnMobile){
                            crudController.deleteSelectedOnMobile();     
                        }
                        else{
                            crudController.deleteSelected();                   
                        }
                    } else if (this.isBehavior && (this.isValidCanvasControl(ev.target) && (Boolean(listService.fcanvas.getActiveObject()) || Boolean(listService.fcanvas.getActiveGroup())))) {
                        ev.returnValue = false;
                        if (ev.target && ev.target.type !== 'text' && ev.target.type !== 'textarea' && ev.target.type !== 'password') {
                            this.stopEvent(ev);
                            crudController.deleteSelectedBehaviors();
                        }else{
                            ev.returnValue = true;
                        }
                    } else if (this.isWorkflow && (this.isValidCanvasControl(ev.target) && (Boolean(listService.fcanvas.getActiveObject()) || Boolean(listService.fcanvas.getActiveGroup())))) {
                        this.stopEvent(ev);
                        ev.returnValue = false;
                        crudController.deleteSelectedWorkflowObjects(); 
                    }
                }
                else if (!this.isSelectionOnLayoutOrReport) {
                    if (listService.mainKind === '' && listService.activeDashboardTab) {
                        if (noTextOrSuppr(ev)) {
                            this.stopEvent(ev);
                            ev.returnValue = false;
                        }    
                    }
                    else {
                        if ((this.isBehaviorOrWorkflow() || this.isLayoutOrReport) && verifyEvent(ev)) {
                            if (noTextOrSuppr(ev)){
                                if (undoService.hasChanges()) {                               
                                    this.stopEvent(ev);
                                    ev.returnValue = false; 
                                    util.removeIfRemainingHelpCenter();                       
                                    formService.confirmSaveOnClose(); 
                                }
                                else {
                                    this.stopEvent(ev);
                                    ev.returnValue = false;  
                                    util.removeIfRemainingHelpCenter();
                                    Backbone.history.loadUrl('saveAndClose');
                                }
                            }
                        }
                    }
                }
            }); 

        // Handle ctrl-s save

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_LC_S && this.isJustCntrlKey(k) && listService.mainKind && (
                listService.docType === constants.DOC_TYPE_FORM || listService.docType === constants.DOC_TYPE_REPORT )))
            .subscribe(ev => {
                this.stopEvent(ev);
                ev.returnValue = false;

                try {
                    // Decouple the action
                    eventBus.trigger(constants.EV_SAVE_CURRENT_FORM);
                } catch (er) {
                    console.log(`cntrl-s suffered an exception: ${er}`);
                }
            });
        
        // Handle ctrl+shift+s Full Save
        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
        .filter(k => (k.ctrlKey && k.shiftKey && k.keyCode === KC_LC_S && listService.mainKind && (
            listService.docType === constants.DOC_TYPE_FORM || listService.docType === constants.DOC_TYPE_REPORT )))
        .subscribe(ev => {
            this.stopEvent(ev);
            ev.returnValue = false;

            try {
                // Decouple the action
                listService.isPartialSave = false; //PF-6641 - Enable key combination to trigger full save
                eventBus.trigger(constants.EV_SAVE_CURRENT_FORM);
            } catch (er) {
                console.log(`cntrl+shift+s suffered an exception: ${er}`);
            }
        });

         // Handle ctrl+alt+s Recovery save
        // Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
        // .filter(k => (k.ctrlKey && k.altKey && k.keyCode === KC_LC_S && listService.mainKind && (
        //     listService.docType === constants.DOC_TYPE_FORM || listService.docType === constants.DOC_TYPE_REPORT )))
        // .subscribe(ev => {
        //     this.stopEvent(ev);
        //     ev.returnValue = false;

        //     try {
        //         listService.isRecoverySave = true;
        //         eventBus.trigger(constants.EV_SAVE_CURRENT_FORM);
        //     } catch (er) {
        //         console.log(`cntrl+alt+s suffered an exception: ${er}`);
        //     }
        // });

        // Handle ctrl-z undo

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_LC_Z && this.isJustCntrlKey(k) && listService.mainKind && (
                listService.docType === constants.DOC_TYPE_FORM || listService.docType === constants.DOC_TYPE_REPORT )))
            .subscribe(ev => {
                this.stopEvent(ev);
                ev.returnValue = false;

                try {
                    undoService.undo();
                } catch (er) {
                    console.log(`cntrl-z suffered an exception: ${er}`);
                }
            });

        // Handle ctrl-y redo
        
        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_LC_Y && this.isJustCntrlKey(k) && listService.mainKind && (
                listService.docType === constants.DOC_TYPE_FORM || listService.docType === constants.DOC_TYPE_REPORT )))
            .subscribe(ev => {
                this.stopEvent(ev);
                ev.returnValue = false;

                try {
                    undoService.redo();
                } catch (er) {
                    console.log(`cntrl-Y suffered an exception: ${er}`);
                }
            });

        // Handle Clipboard key combos' key up

        // Copy
        Rx.Observable.fromEvent(DOM_LOC, KEYUP)
            .filter(k => k.keyCode === KC_LC_C && this.isJustCntrlKey(k) && this.isSelectionOnLayoutOrReport && this.isUIPropertyUnSelected())
            .subscribe(ev => {
                if (this.isValidKBControl(ev.target)) {
                    crudController.copySelected();
                } else if (this.isBehavior) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    crudController.copySelectedBehaviors();
                } else if (this.isWorkflow) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    crudController.copySelectedWorkflowObjects();
                }
            });


        // Cut
        Rx.Observable.fromEvent(DOM_LOC, KEYUP)
            .filter(k => k.keyCode === KC_LC_X && this.isJustCntrlKey(k) && this.isSelectionOnLayoutOrReport && this.isUIPropertyUnSelected())
            .subscribe(ev => {
                if (this.isValidKBControl(ev.target)) {
                    crudController.cutSelected()
                } else if (this.isBehavior) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    crudController.cutSelectedBehaviors();
                } else if (this.isWorkflow) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    crudController.copySelectedWorkflowObjects();
                    crudController.deleteSelectedWorkflowObjects();
                }
            });


        // Paste
        Rx.Observable.fromEvent(DOM_LOC, KEYUP)
            .filter(k => k.keyCode === KC_LC_V && !this.isFormulaOpened() && this.isJustCntrlKey(k) && (this.isLayoutOrReport || this.isBehaviorOrWorkflow()) && this.isUIPropertyUnSelected())
            .subscribe(ev => {
                if (this.isValidKBControl(ev.target) || this.isValidPageObject(ev.target)) {
                    pasteCommandService.addCommandToQueue(crudController.pasteSelected);
                } else if (this.isBehavior || this.isValidPageObject(ev.target)) {
                    this.stopEvent(ev);
                    ev.returnValue = false;

                    const copyProcess = () => {
                        listService.fcanvas.deactivateAll().renderAll();
                        crudController.pasteSelectedBehaviors();
                    };

                    pasteCommandService.addCommandToQueue(copyProcess);
                } else if (this.isWorkflow || this.isValidPageObject(ev.target)) {
                    this.stopEvent(ev);
                    ev.returnValue = false;
                    listService.fcanvas.deactivateAll().renderAll();
                    crudController.pasteSelectedWorkflowObjects();
                }
            });

        //---------------------------- Layout NESW movement via arrow keys (not behavior or workflow) ---------------

        // Move layout object left or right or up or down by 1 or ten pixels
        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(ev => LAYOUT_MOVE_KEYSET[ev.keyCode] &&
                this.isValidKBControl(ev.target) &&
                this.isMaybeShiftKey(ev) &&
                this.isSelectionOnLayoutOrReport)
            .subscribe(ev => this.moveSelectedLayoutControl(ev) );


        // Directionally resize layout object as a function of control-arrow by 1 or pixels
        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(ev => LAYOUT_RESIZE_KEYSET[ev.keyCode] &&
                this.isValidKBControl(ev.target) &&
                this.isJustCntrlKey(ev) &&
                this.isSelectionOnLayoutOrReport)
            .subscribe(ev => this.resizeSelectedLayoutControl(ev) );

        //----------------------------- End:  Layout NESW movement via arrow keys ---------------

        // Delete Items in left panel
        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(k => (k.keyCode === KC_DEL ))
            .subscribe(ev => {

                let noTextEvent= (ev)=> {
                    let isText = false; 
                    if (ev.target) {
                        isText = ev.target.type !== 'text' && ev.target.type !== 'textarea' && ev.target.type !== 'password'; 
                    }
                    
                    return isText;
                }
 
                if (!this.isLayoutOrReportBoolean && !this.isBehavior && !this.isWorkflow && noTextEvent(ev)) {
                    switch (listService.activeDashboardTab) {
                        case "forms":
                            if (listService.dashboardFormsItems.getPropValue('formFolderSelected')) {
                                dashboardService.deleteFormFolder();
                            }

                            if (listService.dashboardFormsItems.getPropValue('formItemSelected')) { 
                                if (!listService.deleteDialogOpened) {
                                    dashboardService.deleteForm();
                                } 
                            }

                            if (listService.dashboardFormsItems.getPropValue('instanceItemSelected')) {
                                dashboardService.deleteInstance();
                            }
                            break;
                        case "reports":
                        
                            if (listService.reportItemSelected) {
                                let nodeType = listService.reportItemSelected.nodeType;
                                if (nodeType && nodeType === "group") {
                                    dashboardService.deleteReportFolder();
                                }
                                else {
                                    dashboardService.deleteReport();
                                }                                
                            }
                            break;
                        case "connections":
                            if (listService.connectionItemSelected) {
                                dashboardService.deleteConnection();
                            }

                            if (listService.actionItemSelected) {
                                dashboardService.deleteAction();
                            }
                            break;
                        case "settings":
                            if (listService.userItemSelected) {
                                dashboardService.deleteUserModal();
                            }

                            if (listService.dashboardSettingsItems.getPropValue('userGroup')) {
                                dashboardService.deleteUserGroup();
                            }

                            if (listService.dashboardSettingsItems.getPropValue('userPosition')) {
                                dashboardService.deleteUserPosition();
                            }

                            if (listService.dashboardSettingsItems.getPropValue('userList')) {
                                dashboardService.deleteUserList();
                            }

                            if (listService.dashboardSettingsItems.getPropValue('userEmail')) {
                                dashboardService.deleteUserEmailServer();
                            }
                            break;
                    }
                }
            });


        // Fabric / HTML5 Canvas widget NESW movement / resize streams (target not an HTML control)

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(ev => FAB_KEY_ACTION[ev.keyCode] && this.isMaybeShiftKey(ev) && this.isBehaviorOrWorkflow() && ev.target.id === 'aForm')
            .subscribe(ev => this.moveFabricWidget(ev));

        Rx.Observable.fromEvent(DOM_LOC, KEYDOWN)
            .filter(ev => FAB_KEY_ACTION[ev.keyCode] && this.isJustCntrlKey(ev) && this.isBehaviorOrWorkflow())
            .subscribe(ev => this.resizeFabricWidget(ev));

    }

    stopEvent(ev) {
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        ev.preventDefault();
    }


    // Returns positive 1 if no modifier keys, or 10 if only shift key down.
    computeAbsoluteDelta(ev) {
        return this.isJustShiftKey(ev) ? 10 : 1;
    }

    isBehaviorOrWorkflow() {
        return listService.mainKind === constants.KIND_BEHAVIORS || listService.mainKind === constants.KIND_WORKFLOW;
    }

    isFormulaOpened(){
       return $("#formulaModal").is(':visible');
    }

    // Said in English: no mode key or only control key or only shift key
    isMaybeJustCntrlKeyOrShiftKey(k) {
        return !this.isAnyModeKey(k) || this.isJustCntrlKey(k) || this.isJustShiftKey(k);
    }

    // PF-3069
    // Method that checks for a property to not be selected in order to not consider the pasting of the currently selected control in the canvas.
    isUIPropertyUnSelected() {
        return $(".pfSelectedBlue").length === 0;
    }

    isJustCntrlKey(k) {
        return (k.ctrlKey || k.metaKey) && !(k.shiftKey || k.altKey);
    }

    isAnyModeKey(k) {
        return k.metaKey || k.ctrlKey || k.shiftKey || k.altKey;
    }

    isJustShiftKey(k) {
        return k.shiftKey && !(k.metaKey || k.ctrlKey || k.altKey);
    }

    isMaybeShiftKey(k) {
        return !(k.metaKey || k.ctrlKey || k.altKey);
    }

    get isSelectionOnLayoutOrReport() {
        return ((this.isLayoutOrReport && listService.selectedCount > 0) || listService.areThereSelectedCanvasObjects);
    }

    get isSelectionOnMobile() {
        return ((this.isMobile && listService.selectedCount > 0));
    }

    get isLayoutOrReport() {
        return listService.mainKind === constants.KIND_LAYOUT || listService.mainKind === constants.KIND_REPORT;
    }

    get isMobile() {
        return listService.mainKind === constants.KIND_MOBILE;
    }

    get isLayoutOrReportBoolean() {
        return this.isLayoutOrReport;
    }

    get isBehavior() {
        return listService.mainKind === constants.KIND_BEHAVIORS;
    }

    get isWorkflow() {
        return listService.mainKind === constants.KIND_WORKFLOW;
    }

    // PF-1155 Adding an extra validation for handling timer control, as it is not on the canvas I needed to look for it on the selected collection of items.
    isValidKBControl(target) {
        return target.classList.contains('pf-control') || listService.selectedAsset || this.isTimerObjectSelected(target);
    }

    isValidCanvasControl(target){
        return target.nodeName.toLowerCase() === 'body' || target.id === 'aForm' ;
    }

    isTimerObjectSelected(target){
      return target.localName === 'body' &&
          listService.selected.some((elem)=>
          {
              return elem && elem.model.get('factoryKey') ==='control_timer'
          })
    }

    isValidPageObject(target) {
        return target.id === constants.PAGESEL;
    }


    //======================================================================================================
    // This method is for layout only (html on forms / reports).
    //======================================================================================================
    resizeSelectedLayoutControl(ev) {
        this.stopEvent(ev);

        // Iterate map of selected controls held by listService, attempting a resize on each:
        listService.selected.forEach( c => {

            const
                m = c.model,
                s = LAYOUT_RESIZE_KEYSET[ev.keyCode],
                minWidth = util.extractNum(m.get('minWidth')),
                minHeight = util.extractNum(m.get('minHeight')),
                newRect = {
                    width: Math.max(minWidth, (s.dwidth || 0) + util.extractNum(m.get('width'))),
                    height: Math.max(minHeight, (s.dheight || 0) + util.extractNum(m.get('height'))),
                    left: util.extractNum(m.get('left')),
                    top: util.extractNum(m.get('top'))
                };

            // Resize the element only if new size fits
            if (KeyboardController.rect1ContainsRect2( this.pageRect, newRect ) ) {
                m.set(newRect);
            }

        });
    }

    get pageRect() {
        const pageDim = (() => {
            const $canvas = $(constants.PAGE_ID);
            return {
                width: util.extractNum($canvas.width()) + 2,
                height: util.extractNum($canvas.height()) + 2
            };
        })();

        return {
            top: 0,
            left: 0,
            height: pageDim.height,
            width: pageDim.width
        };
    }


    // Dev note: Geometry service method of this name didn't do this job correctly, hence, this one
    static rect1ContainsRect2(r1, r2) {
        const isContained =
            (r1.left < r2.left || r2.left === 0) &&
            (r1.left + r1.width - 2 > r2.left + r2.width) &&
            (r1.top < r2.top || r2.top === 0) &&
            (r1.top + r1.height - 2 > r2.top + r2.height);
        return isContained;
    }


    // Checking if attempt to place part of element outside the page
    // Params: delta, model, spec
    isRectContainedInPage(newRect, inRect ) {
        // Compute the potentials movement result rect
        const elemRect = {
            left: newRect.left,
            top: newRect.top,
            width: inRect.width,
            height: inRect.height
        };

        // New position entirely contained on page?
        return KeyboardController.rect1ContainsRect2( this.pageRect, elemRect );
    }

    // Checking if attempt to place part of element outside its group
    isRectContainedInGroup(newRect, inRect, groupId ) {
        // Compute the potentials movement result rect
        const elemRect = {
            left: newRect.left,
            top: newRect.top,
            width: inRect.width,
            height: inRect.height
        };
        const group = listService.getObject(groupId);
        const groupRect = {
            left: 0,
            top: 0,
            width: util.extractNum(group.model.get('width')) + 3,
            height: util.extractNum(group.model.get('height')) + 3
        }
        // New position entirely contained on group?
        return KeyboardController.rect1ContainsRect2(groupRect, elemRect );
    }

    //======================================================================================================
    // This method is for layout (html on forms / reports) only.
    //======================================================================================================
    moveSelectedLayoutControl(ev) {
        this.stopEvent(ev);

        // Iterate map of selected controls held by listService
        listService.selected.forEach(c => {

            // Increment controls` left or top by signed amount
            // Backbone triggers one view update

            const
                d = this.computeAbsoluteDelta(ev),
                m = c.model,
                s = LAYOUT_MOVE_KEYSET[ev.keyCode],
                inbound = {
                    left: util.extractNum(m.get('left')),
                    top: util.extractNum(m.get('top')),
                    width: util.extractNum(m.get('width')),
                    height: util.extractNum(m.get('height'))
                };           
            const groupId = listService.getGroupObject(m.get('id'));
            const $el = $(constants.ID_SEL + m.get("id"));


            // Check move. Move if fits. Otherwise decrement deltas by 1 to 0, retrying fit at each step.
            for(let d2 = d; d2 > 0; --d2) {
                const movedRect = {
                    left: s.delta.dx * d2 + inbound.left,
                    top: s.delta.dy * d2 + inbound.top
                };

                //PF-9523 there is an offset of 4px in tables because of the resizing handles, 
                //the offset should only be taken into account in the visual position but not the position in the model
                let tableOffset = 0;
                if (m.get("factoryKey") === "control_table") {
                    tableOffset = 4;
                }

                if(groupId && groupId !== ''){
                    if (this.isRectContainedInGroup(movedRect, inbound, groupId)) {

                        undoService.add({
                            undo:() => {
                                m.set({left: inbound.left, top: inbound.top},constants.MODEL_SILENT);
                                focusController.selectionRectangle( m.get('id') );
                                $el.css({ 'top': inbound.top - tableOffset, 'left':  inbound.left });
                            },
                            redo: () => {
                                m.set({left: movedRect.left, top: movedRect.top},constants.MODEL_SILENT);
                                focusController.selectionRectangle( m.get('id') );
                                $el.css({ 'top': movedRect.top - tableOffset, 'left': movedRect.left });
                            }
                        },  textConstants.UNDO_MOVE);

                       // The actual move:
                       m.set( movedRect, SILENT );
                       $el.css({ 'top': movedRect.top - tableOffset, 'left': movedRect.left });
                        
                       break;
                    }
                 }else if (this.isRectContainedInPage(movedRect, inbound)) {

                    undoService.add({
                        undo:() => {
                            m.set({left: inbound.left, top: inbound.top},constants.MODEL_SILENT);
                            focusController.selectionRectangle( m.get('id') );
                            $el.css({ 'top': inbound.top - tableOffset, 'left':  inbound.left });
                        },
                        redo: () => {
                            m.set({left: movedRect.left, top: movedRect.top},constants.MODEL_SILENT);
                            focusController.selectionRectangle( m.get('id') );
                            $el.css({ 'top': movedRect.top - tableOffset, 'left': movedRect.left });
                        }
                    },  textConstants.UNDO_MOVE);
                    
                     // The actual move:
                     m.set( movedRect, SILENT );
                     $el.css({ 'top': movedRect.top - tableOffset, 'left': movedRect.left });
                     break;
                 }

                 
            }

        });

    }

    //==============================================================================================================
    // Create and return a fake mouse event for use by keyboard handler
    //==============================================================================================================
    createFakeMouseEvent(obj, ev) {
        const
            localEvent = typeof event !== 'undefined' && typeof event.keyCode !== 'undefined' ? event: ev,
            move_coord = FAB_KEY_ACTION[localEvent.keyCode].pfCoord,
            coord = `page${move_coord.toUpperCase()}`,
            x = this.$aForm.offset().left + obj.left + obj.width / 2,
            y = this.$aForm.offset().top + obj.top + obj.height / 2;

        const pseudoEvent = {
            x: x,
            y: y,
            scaleX: obj.scaleX,
            scaleY: obj.scaleY,
            pageX: x,
            pageY: y,
            keyboardMove: true
        };
        pseudoEvent[coord] = pseudoEvent[coord] + FAB_KEY_ACTION[localEvent.keyCode].direction;

        return {
            target: obj, x: x, y: y, scaleX: obj.scaleX, scaleY: obj.scaleY,
            e: pseudoEvent
        };
    }

    //==============================================================================================================
    // Is the argument a connection arrow BB view?
    //==============================================================================================================
    isConnectionArrow(view) {
        return view && view.model && view.model.get('factoryKey') === 'connection_arrow';
    }


    //==============================================================================================================
    // Is the argument a branch or multi-branch BB view?
    //==============================================================================================================
    isBranch(view) {
        const key = 'factoryKey';
        return view && view.model &&
            ( view.model.get(key) === 'command_simple_branch' ||
                view.model.get(key) ==='command_multiple_branch' );
    }



    //==============================================================================================================
    // Move fabric-backbone synced widget in any NSEW direction for a signed  pixel amount,  according to
    // cntrl-arrow key press.
    //==============================================================================================================

    moveFabricWidget(ev) {
        this.stopEvent(ev);

        // PF-2859: Stop the element from moving while the mouse is pressed/dragging
        if (listService.isElementMoving) { return; }
        const
            canvas = listService.fcanvas,
            active = canvas.getActiveObject() || canvas.getActiveGroup();
        
        // Move selection only if there is a single-widget selection that is not a connection,
        if (active && !this.isConnectionArrow(active)) {

            const
                objs = active.model ? [active] : active.objects,
                s = FAB_KEY_ACTION[ev.keyCode];

            // Signed delta growth:
            let d = this.computeAbsoluteDelta(ev) * s.direction;

            objs.forEach(w => {
                if ((w.model.get(s.pfCoord) + d ) < 0) {
                    d -= w.model.get(s.pfCoord) + d;
                }
            });

            canvas.trigger('mouse:down', this.createFakeMouseEvent(active, ev));
            // Records the change in model's backing store so that the object will re-constitute
            // after view change or save/reload

            objs.forEach(w => w.model.set(s.pfCoord, Number(w.model.get(s.pfCoord)) + d, SILENT));

            // Remainder of code moves the object visually on the canvas with sticky connection tracking

            active.set(s.fabCoord, active.get(s.fabCoord) + d);

            // Repaint object in its new location. (Not if a marked group)
            if (active.model) {
                canvas.setActiveObject(active);
            }

            // Track connections by injecting object:moving event during mouse down.
            // The mouse:down handler adjusts any sticky connection endpoint coordinates

            canvas.trigger('object:moving', this.createFakeMouseEvent(active, ev));
            canvas.trigger('mouse:up', this.createFakeMouseEvent(active, ev));

            // PF-2859: To continue with the logic for mouse:move (avoid moving the elements with the keyboard while moving them with the mouse)
            listService.isElementMoving = false;

            canvas.renderAll();
            objs.forEach(w => {
                this.checkObjectLocation(listService.fcanvas, util.extractNum( w.model.get('y')) , util.extractNum( w.model.get('x')), w.model );
            });
        }
    }

    //==============================================================================================================
    // Resize fabric-backbone synced widget in-plance direction for any signed reasonable pixel amount,
    // according to cntrl-arrow key press.
    //
    // 1. Relocate anchored connections on resized object.
    // 2. Resize groups. (iterate (1.) for each member)
    //------------------------------------------------------------------------------------
    // Note on connection line and dots data structure (hard to remember):
    // ------------------------------------------------------------------------------------
    //  Connection
    //      end: 'A End'
    //      line: klass
    //          model: BehaviorModel
    //              attributes:
    //                  widget: klass
    //                      _objects[5]
    //                          0: klass (the visible shape object)
    //                          1: klass (dot 0)
    //                          2: klass (dot 1)
    //                          3: klass (dot 2)
    //                          4: klass (dot 3)
    //      model: LineModel
    //          attributes:
    //              owners:
    //                  dest: PF_11
    //                  src: PF_12
    //  ----------------------------------------------------------------------------
    //==============================================================================================================
    resizeFabricWidget(ev) {

        this.stopEvent(ev);

        const fnCompensateLocation = ( d => d * RESIZE_STEP );

        const
            canvas = listService.fcanvas,
            activeObject = canvas.getActiveObject(),
            _this = this;

        // We ignore resize requests for individual objects within groups
        const activeColl = activeObject ? [activeObject] : [];

        // Resize one selection or multi-selection
        const resizeSelected = _.forEach(activeColl, (active) => {

            // Resize selection only if there is a single-widget selection that is not a connection,
            if (active && !this.isConnectionArrow(active)) {

                const
                    objs = active.model ? [active] : active.objects,
                    spec = FAB_KEY_ACTION[ev.keyCode];

                const
                    key1 = active.model ? active.model.get('factoryKey') : DEFAULT,
                    key2 = MIN_DIMS[key1] ? key1 : DEFAULT;

                // Absolute resize px scalar
                const d = this.computeAbsoluteDelta(ev) * spec.direction;

                // A. Resize the object(spec) in BB model store so that the object will re-constitute after
                // view change or save/reload:

                const fnResizeCircle = (w => {

                    // Resize branches on another JIRA ticket
                    if (!WANT_RESIZE_CIRCLES) {
                        return false;
                    }
                    // Resize object in backbone model.
                    const oldSize = util.extractNum(w.model.get('width'));
                    const newSize = {
                        'width': Math.max(MIN_DIMS[key2]['width'], oldSize + d),
                        'height': Math.max(MIN_DIMS[key2]['height'], oldSize + d)
                    };
                    w.model.set(newSize, SILENT);
                    return oldSize !== util.extractNum(w.model.get('width'));
                });

                const fnResizeRect = (w => {
                    // Resize object in backbone model.
                    const oldSize = util.extractNum(w.model.get(spec.dim));
                    w.model.set(spec.dim, Math.max(MIN_DIMS[key2][spec.dim],  oldSize + d), SILENT);
                    return oldSize !== util.extractNum(w.model.get(spec.dim));
                });

                const isResized =  _this.isBranch(active) ? fnResizeCircle( active ) : fnResizeRect( active );

                // B. Adjust position of selected object only if object is resized now. Goal is to maintain its center position.
                if (isResized) {
                    // Offset the position of the fabric rendered widget or group on the canvas (set and get are Fabric methods)
                    // We'll handle the connection ends later

                    if (_this.isBranch(active)){
                        // Resize branches on another JIRA ticket
                        if (WANT_RESIZE_CIRCLES) {
                            active.set('left', active.get('left') - fnCompensateLocation(d));
                            active.set('top', active.get('top') - fnCompensateLocation(d));
                        }
                    } else {
                        active.set(spec.fabCoord, active.get(spec.fabCoord) - fnCompensateLocation(d));
                    }

                    // Repaint object in its new size.
                    active.model.trigger('change', active.model);
                    canvas.setActiveObject(active);

                    // Resize is easy, but tracking sticky connections is more work.
                    // Adjust connection anchor locations across active dimension change.
                    // Nudge each B_END(dest) or each A_END(src) coordinate by dot delta for its dot parent position.
                    // Function for rectangular widgets create 2-D delta of the line-end coordinate for the dot widget of the dot number

                    // This function not called for circular shapes.
                    const fnGenDeltaPoint = (fc, d) => ( {dx: fc === 'left' ? d : 0, dy: fc === 'top' ? d : 0} );

                    _.forEach(active.connection, c => {

                        // Determine  end of line, so we can pick up the dot number for that end:
                        const dotNum = c.line.model.get(c.end === constants.A_END ? 'srcDot' : 'destDot');

                        if (_this.isBranch(active)) {
                            // Resize branches on another JIRA ticket
                            if (WANT_RESIZE_CIRCLES) {
                                const drow = CIRCLE_DOT_DELTAS[dotNum];
                                const deltaPoint = {};
                                deltaPoint.dx = drow.dx * -spec.direction;
                                deltaPoint.dy = drow.dy * -spec.direction;

                                // Nudge the line-end
                                ConnectionTracker.moveEndOfConnectionOfCircle(c, deltaPoint);
                            }
                        } else {
                            // Four points, origin 0 is east, proceeding clockwise
                            // Signed directional delta px value on axis specified by fabCoord.
                            const deltaScalarPX = DOT_DELTAS[spec.fabCoord][dotNum] * -spec.direction;

                            // Nudge the line-end
                            let connectionPosition = fnGenDeltaPoint(spec.fabCoord, deltaScalarPX);
                            // PF-2859: Nudge top position only... control grows both ends horizontally 
                            if ( (constants.KIND_BEHAVIORS + constants.KIND_WORKFLOW).includes(listService.mainKind) ) {
                                connectionPosition.dx = 0;
                                connectionPosition.dy = 0;
                                if (ev.keyCode === KC_DOWN) {
                                    connectionPosition.dy = c.end === constants.A_END ? RESIZE_STEP : -RESIZE_STEP;
                                } else if (ev.keyCode === KC_UP) {
                                    connectionPosition.dy = c.end === constants.A_END ? -RESIZE_STEP : RESIZE_STEP;
                                }
                            }
                            ConnectionTracker.moveEndOfConnection(c, connectionPosition);
                        }

                    });
                    // PF-2859: Removed mouse:down & mouse:moving event triggers
                    // not needed, as mouse:up is enough to draw the position for every pixel moved
                    canvas.trigger('mouse:up', {target: active, e: this.createFakeMouseEvent(active, ev)});
                    canvas.renderAll();

                }
            }
        });

    }

    checkObjectLocation(fcanvas, top, left, model) {
        // check if out of bounds
        const canvasRawId = 'aPageSel';
        const rightEdge = Number(model.get('width')) + Number(left);
        const bottomEdge = Number(model.get('height')) + Number(top);
        const buffer = 10;
        if ( rightEdge+buffer > fcanvas.width) {
            const newWidth = rightEdge+buffer;
            if (listService.mainKind === constants.KIND_BEHAVIORS) {
                eventBus.trigger('resizeBehaviorCanvas', canvasRawId, newWidth, fcanvas.height);
            }

            if (listService.mainKind === constants.KIND_WORKFLOW) {
                eventBus.trigger('resizeWorkflowCanvas', canvasRawId, newWidth, fcanvas.height);
            }
        }

        if (bottomEdge+buffer > fcanvas.height) {
            const newHeight = bottomEdge+buffer;

            if (listService.mainKind === constants.KIND_BEHAVIORS) {
                eventBus.trigger('resizeBehaviorCanvas', canvasRawId, fcanvas.width, newHeight);
            }

            if (listService.mainKind === constants.KIND_WORKFLOW) {
                eventBus.trigger('resizeWorkflowCanvas', canvasRawId, fcanvas.width, newHeight);
            }
        }

    }
}

const keyboardController = new KeyboardController();
export default  keyboardController;

